import { CURRENCY_LABEL } from "../components/common";
import { getCartItems } from "../components/cart";

export function checkPromoCode(promoCode) {
    promoCode = promoCode && $(this).parent().find('input').val();
    if (!promoCode) {
        return;
    }
    $(this).prop('disabled', true);
    /*
     *  Return object:
     *  {
     *      discount: number
     *      message: string
     *      promoCode: string
     *      success: boolean
     *      type: number
     *  }
     *
     *  Types:
     *  1 - Percent
     *  2 - RON
     */
    $.ajax({
        type: 'GET',
        url: `/ajax/promocode?promocode=${promoCode}`,
        dataType: "json",
        success: (res) => {
            console.log('promoCode', res);
            $(this).prop('disabled', false);
            // __applyPromoCode__OLD_CHECKOUT_PAGE(res);
            applyPromoCode(res);
            getCartItems();
        },
        error: () => {
            $(this).prop('disabled', false);
        }
    });
}

// todo: Remove when checkout redesign will be finished
export function __applyPromoCode__OLD_CHECKOUT_PAGE(res) {
    const appliedPromoCodeChildren = $('.applied-promo-code').addClass('active').find('span');
    const totalPriceValueElement = $('.summary-cart-box, .payment-form').find('.total-price .total-price-value');
    const originalPrice = parseFloat(totalPriceValueElement.attr('data-original-price'));
    if (res.success) {
        $('.promo-code-form').removeClass('promo-code-form--wrong-code');
        //$('.promo-code-form input').val('');
        // const findPriceRegexp = /^(?:\D*)?(?<price>[\d,.]*)(?:\D*)?$/g;
        let totalReducedPrice = 0;
        let discountSuffix = '';
        let discountValue = '';
        switch (res.type) {
            case 1:
                discountSuffix = '%';
                totalReducedPrice = originalPrice - (originalPrice / 100 * res.discount);
                discountValue = res.discount;
                break;
            case 2:
                discountSuffix = ` ${CURRENCY_LABEL}`;
                totalReducedPrice = originalPrice - res.flatSum;
                discountValue = res.flatSum;
                break;
        }
        if (totalReducedPrice < 0) {
            totalReducedPrice = 0;
        }
        appliedPromoCodeChildren.eq(0).text(`Codul ${res.promoCode}:`);
        appliedPromoCodeChildren.eq(1).text(`-${discountValue} ${discountSuffix}`);
        const newTotalPrice = res.totalCartPrice ?? parseFloat(totalReducedPrice.toFixed(2));
        totalPriceValueElement.text(newTotalPrice);
    } else {
        $('.applied-promo-code').removeClass('active');
        appliedPromoCodeChildren.text('');
        $('.promo-code-form').addClass('promo-code-form--wrong-code');
        totalPriceValueElement.text(originalPrice);
    }
}

export function applyPromoCode(res) {
    const promoCodeInputWrapper = $('.checkout-page .promo-code');
    const appliedPromoCodeDt = $('.checkout-page .order-summary .order-summary__applied-promo-code');
    const totalPriceValueDt = $('.checkout-page .order-summary .order-summary__total-price');
    const originalPrice = parseFloat(totalPriceValueDt.find('+ dd').attr('data-original-price'));
    if (res.success) {
        promoCodeInputWrapper.removeClass('promo-code--wrong-code');
        promoCodeInputWrapper.removeClass('promo-code--accepted-code-prefilled');
        promoCodeInputWrapper.addClass('promo-code--accepted-code');
        //$('.promo-code-form input').val('');
        // const findPriceRegexp = /^(?:\D*)?(?<price>[\d,.]*)(?:\D*)?$/g;
        let totalReducedPrice = 0;
        let discountSuffix = '';
        let discountValue = '';
        switch (res.type) {
            case 1:
                discountSuffix = '%';
                totalReducedPrice = originalPrice - (originalPrice / 100 * res.discount);
                discountValue = res.discount;
                break;
            case 2:
                discountSuffix = ` ${CURRENCY_LABEL}`;
                totalReducedPrice = originalPrice - res.flatSum;
                discountValue = res.flatSum;
                break;
        }
        if (totalReducedPrice < 0) {
            totalReducedPrice = 0;
        }
        appliedPromoCodeDt.addClass('active');
        // appliedPromoCodeDt.find('span').text(`${res.promoCode}`)
        appliedPromoCodeDt.find('+ dd span').text(`- ${discountValue} ${discountSuffix}`);
        const newTotalPrice = res.totalCartPrice ?? parseFloat(totalReducedPrice.toFixed(2));
        totalPriceValueDt.find('+ dd span').text(newTotalPrice);
    } else {
        promoCodeInputWrapper.addClass('promo-code--wrong-code');
        promoCodeInputWrapper.removeClass('promo-code--accepted-code');
        promoCodeInputWrapper.removeClass('promo-code--accepted-code-prefilled');
        appliedPromoCodeDt.removeClass('active');
        appliedPromoCodeDt.find('span').text(``)
        appliedPromoCodeDt.find('+ dd span').text(`-`);
        totalPriceValueDt.find('+ dd span').text(originalPrice);
    }
}

export function onMainLocalityChange() {
    const locality = $('.checkout-page select[name="locality"]');
    locality.html(`<option value="" selected disabled>Loading...</option>`);
    const idparent = $(this).val();
    $.ajax({
        type: "POST",
        url: '/ajax/getsublocality',
        dataType: 'json',
        data: {idparent: idparent},
        success: (res) => {
            if (res.success) {
                const options = res.locality.map((item) => {
                    return `<option value="${item.id}">${item.name}</option>`;
                });
                const placeholder = '<option value="" selected disabled>Selectați localitate</option>';
                locality.html([placeholder,...options].join(`\n`));
                $('.checkout-page .order-summary__delivery-price + dd span').text(`${res.deliveryPrice} RON`);
                $('.checkout-page input[name="deliveryPrice"]').val(res.deliveryPrice);
            } else {
                console.log('error response', res);
            }
        },
    });
}

export function onLocalityChange() {
    const idlocality = $(this).val();
    $.ajax({
        type: "POST",
        url: '/ajax/getlocality',
        dataType: 'json',
        data: {idlocality: idlocality},
        success: (res) => {
            if (res.success) {
                $('.checkout-page .order-summary__delivery-price + dd span').text(`${res.deliveryPrice} RON`);
                $('.checkout-page input[name="deliveryPrice"]').val(res.deliveryPrice);
            } else {
                console.log('error response', res);
            }
        },
    });
}

export async function checkAdBlock() {
    let isAdBlockEnabled = false;
    const googleAdUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

    try {
        await fetch(new Request(googleAdUrl)).catch(() => isAdBlockEnabled = true)
    } catch (e) {
        isAdBlockEnabled = true
    } finally {
        //console.log(`AdBlock Enabled: ${isAdBlockEnabled}`)
        if(isAdBlockEnabled){
            $.get("/ajax/checkadblocker");
        }
    }
}

export function makeCartModalReadOnly() {
    const modal = $('.checkout-page + .container .modal.cart-modal');
    const cartItemsCount = modal.find('.cart-product').length;
    modal.find('.modal__head').text(`Coșul tău (${cartItemsCount})`);
    modal.find('.modal__footer--checkout-view button').text('Înapoi la finalizarea comenzii.');
    modal.find('.cart-product__mobile-menu, .cart-product__image-container a').remove();
    modal.find('a.cart-product__name').replaceWith(function() {
        return '<span class="cart-product__name">' + $(this).text() + '</span>'
    });
}

export function scrollToErrorField() {
    const firstErrorElement = $(this).closest('form').find('select:invalid, input:invalid, textarea:invalid').first().get(0);

    if (this === firstErrorElement) {
        const navbar = $('header.header__container');
        const navbarHeight = navbar.height() + 36;
        const elementOffset = $(this).offset().top - navbarHeight;

        $('html,body').animate({
            scrollTop: elementOffset
        }, 100);
    }
}

export default function init() {
    if (!$('.checkout-page').length) {
        return;
    }

    $('.checkout-page .promo-code button').on('click', checkPromoCode);

    $('.checkout-page select[name="mainLocality"]').on('change', onMainLocalityChange);
    $('.checkout-page select[name="locality"]').on('change', onLocalityChange);

    $('.checkout-page select, .checkout-page input, .checkout-page textarea').on('invalid', scrollToErrorField);

    checkAdBlock();

    makeCartModalReadOnly();
}
